import type { IEquipo } from "./entidades/IEquipo";
import type { ICatalogo, IRespuestaApiLista, IRespuestaApiObjeto } from "../../globales/interfaces";
import api from "../../utils/api";
import type { IModeloEquipo } from "./entidades/IModeloEquipo";
import type { IFiltroEquipo } from "./entidades/IFiltroEquipo";

export class EquipoModelo {
    

    constructor() { }
    public async obtenerListaEquipos(filtro: IFiltroEquipo): Promise<IRespuestaApiLista<IEquipo>> {
        const { data } = await api.post(
            `/api/Equipos/ListarCompuesto`, filtro, {
            headers: {
                "Content-Type": "application/json"
            },
        });
        return data;
    }

    public async crearEquipo(equipo: IEquipo): Promise<IRespuestaApiObjeto<IEquipo>> {
        const { data } = await api.post(
            `/api/Equipos/Crear`, equipo, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async editarEquipo(equipo: IEquipo): Promise<IRespuestaApiObjeto<IEquipo>> {
        const { data } = await api.put(
            `/api/Equipos/Actualizar`, equipo, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async eliminarEquipo(equipo: IEquipo): Promise<IRespuestaApiObjeto<IEquipo>> {
        const { data } = await api.delete(
            `/api/Equipos/Eliminar/${equipo.Id}`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async obtenerListaTiposEquipos(): Promise<IRespuestaApiLista<ICatalogo>> {
        const { data } = await api.get(
            `/api/TipoEquipos/Listar`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }


    public async obtenerListaMarcasEquipo(): Promise<IRespuestaApiLista<ICatalogo>> {
        const { data } = await api.get(
            `/api/MarcaEquipos/Listar`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async obtenerListaModelosEquipo(): Promise<IRespuestaApiLista<IModeloEquipo>> {
        const { data } = await api.get(
            `/api/ModeloEquipos/Listar`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async obtenerListaEstadosEquipo(): Promise<IRespuestaApiLista<ICatalogo>> {
        const { data } = await api.get(
            `/api/EstadoEquipos/Listar`, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async descargarPlantilla(): Promise<void> {
        const response = await api.get(`/api/Equipos/DescargarPlantilla`, {
            responseType: "blob", // 👈 para recibirlo como archivo
        });

        // Crear un enlace temporal para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        // Nombre del archivo (puedes obtenerlo del header)
        const disposition = response.headers["content-disposition"];
        let filename = "Plantilla_Equipo.xlsx";
        if (disposition && disposition.includes("filename=")) {
            const match = disposition.match(/filename\*?=['"]?(?:UTF-8'')?([^;]+)/);
            if (match && match[1]) {
                filename = decodeURIComponent(match[1].replace(/['"]/g, ""));
            }
        }

        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Liberar URL
        window.URL.revokeObjectURL(url);
    }

    public async cargarMasiva(archivo: File): Promise<IRespuestaApiObjeto<string>> {
        const formData = new FormData();
        formData.append("archivo", archivo);

        const { data } = await api.post(`/api/Equipos/CargarMasiva`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return data;
    }
}

